"use memo"

import { ReactNode } from 'react'
import clsx from 'clsx'
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2'
import './CampaignTabHeader.scss'

type CampaignTabHeaderVariant = 'panel' | 'tertiary'

interface CampaignTabHeaderProps {
  actions?: ReactNode
  title?: ReactNode
  titleId?: string
  variant?: CampaignTabHeaderVariant
}

const CampaignTabHeader = ({
  actions,
  title,
  titleId = 'campaignTabHeaderTitle',
  variant = 'panel',
}: CampaignTabHeaderProps) => (
  <AgxSpacer
    className={clsx('campaignTabHeader', `campaignTabHeader--${variant}`)}
    direction="horizontal"
    gap="spacing-xl"
    contentAlignment="center"
    contentJustification="space-between"
  >
    {title && (
      <AgxTypography id={titleId} type="heading" size="x-small">
        {title}
      </AgxTypography>
    )}
    {actions}
  </AgxSpacer>
)

export default CampaignTabHeader
